let ModuleBanner = {
    Module: require("./modules/Module"),
    Banner: require("./modules/ModuleBanner")
};
window.Modules = { ...window.Modules, ...ModuleBanner };